var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 46C38.7247 46 49.25 36.2628 49.25 24C49.25 11.7372 38.7247 2 26 2C13.2753 2 2.75 11.7372 2.75 24C2.75 36.2628 13.2753 46 26 46Z",
    fill: "#1A1A1A",
    stroke: "#0D0D0D",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_5244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.957 27.1358L29.8533 30.0321M29.8533 30.0321L32.7504 27.1358M29.8533 30.0321L29.8538 17.9653",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5434 20.862L21.6471 17.9648M21.6471 17.9648L18.75 20.862M21.6471 17.9648L21.6467 30.032",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_5244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13.75 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swapIcon.0f2fb67a8d360acf347cfac18f139311.svg";
export { ForwardRef as ReactComponent };